module.exports = __webpack_public_path__ + "static/media/msr.7567ea83.svg";